import { render, staticRenderFns } from "./ToolkitTripleATab.vue?vue&type=template&id=0470da17&scoped=true"
import script from "./ToolkitTripleATab.vue?vue&type=script&lang=js"
export * from "./ToolkitTripleATab.vue?vue&type=script&lang=js"
import style0 from "./ToolkitTripleATab.vue?vue&type=style&index=0&id=0470da17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0470da17",
  null
  
)

export default component.exports